<section class="storyblok-blok-container">
  <div class="usp-grid" appIsVisible (isVisible)="initializeUspGridView()">
    <div class="usp-grid__title-area">
      <h2>{{ 'SHARED.USP.MAIN_HEADLINE' | translate }}</h2>
      <p>{{ 'SHARED.USP.MAIN_SUBLINE' | translate }}</p>
    </div>

    <div class="usp-grid__card-grid">
      <app-usp-card
        *ngFor="let card of uspDefaultCards"
        [card]="card"
        [isMobile]="isMobile"
        [market]="market"
      ></app-usp-card>
    </div>

    <p
      *ngIf="market === IT_MARKET"
      class="usp-grid__disclaimer"
      [innerHTML]="
      getDisclaimerText(
        'SHARED.USP.DISCLAIMER.INTRO' | translate,
        'SHARED.USP.DISCLAIMER.LINK' | translate,
        'SHARED.USP.DISCLAIMER.ENDING' | translate
      ) | sanitize
    "
    ></p>
  </div>
</section>
